import Notifications, { notify } from '@kyvg/vue3-notification'
import velocity from 'velocity-animate'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(Notifications, { velocity })
  nuxtApp.provide('notify', notify)
})
